export const fileTypesIds = {
  step2: {
    israeliId: "id",
    passport: "passport",
    workingVisaPermit: "workVisa"
  },
  step6: {
    signature: 'signature_contract'
  },
  step9: {
    signature: 'signature_6101'
  },
  step13: {
    disabled: 'disabledCert',
    permanentResidence: 'residanceCert',
    newImmigrant: 'immigrantCert',
    returningCitizen: 'returningCitizenCert',
    disabledKid: 'disabledKidCert',
    spouseAlimony: 'spouseAlimonyCert',
    militaryDischarge: 'militaryDischargeCert',
    graduation: 'graduationCert',
},
  step14: {
    signature: 'signature_101'
  },
  step15: {
    taxAdjustmentPDF: 'taxAdjustment'
  }
};
